import SEOHead from "../../components/shared/SEOHead.jsx";
import SimplePage from "../../components/shared/SimplePage.jsx";
import { DatenschutzDe, DatenschutzEn } from "./DatenschutzContent.jsx";

// German is the legally binding version — see DatenschutzContent.jsx for
// the real text (DE authoritative, EN a courtesy translation, same
// convention as AgbContent.jsx) and konzepte/datenschutzerklaerung.html
// for the source template (a generic DSGVO-generator document, trimmed to
// what this codebase actually does — see that component's doc comment).
export default function Datenschutz({ lang }) {
  const path = lang === "de" ? "/datenschutz" : "/privacy";
  const altPath = lang === "de" ? "/privacy" : "/datenschutz";
  const title = lang === "de" ? "Datenschutz" : "Privacy Policy";

  return (
    <>
      <SEOHead lang={lang} path={path} altPath={altPath} title={title} noindex />
      <SimplePage title={title} maxWidth="900px">
        {lang === "de" ? <DatenschutzDe /> : <DatenschutzEn />}
      </SimplePage>
    </>
  );
}
